export default "__VITE_ASSET__Dl9EXzU7__"